<template>
  <div class="no_data">
    <img :src="require('static/img/nodata.png')" alt="" />
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
.no_data {
  text-align: center;
}
</style>
